/**
 * List layout — nodes stacked vertically (or horizontally), indented by level.
 * No connectors. Sub-level nodes render narrower and inset.
 */
import { paletteColor } from '../smartArtUtils';

const PAD = 6; // outer padding (%)
const SIDE_PAD = 3; // outer left/right padding for horizontal layouts (%) — kept small so wide containers don't show large side margins
const GAP = 4; // gap between boxes (%)
const INDENT_STEP = 6; // left inset per level (%)

export const layoutList = (nodes, theme, variant = 'vertical') => {
  const boxes = [];
  if (!nodes.length) return { boxes, connectors: [] };

  if (variant === 'horizontal') {
    const innerW = 100 - SIDE_PAD * 2;
    const totalGap = GAP * (nodes.length - 1);
    const wPct = (innerW - totalGap) / nodes.length;
    nodes.forEach((node, i) => {
      boxes.push({
        nodeId: node.id,
        xPct: SIDE_PAD + i * (wPct + GAP),
        yPct: PAD,
        wPct,
        hPct: 100 - PAD * 2,
        shapeType: 'rectangle',
        fill: paletteColor(theme, i),
        textColor: theme.textColor,
      });
    });
    return { boxes, connectors: [] };
  }

  const innerH = 100 - PAD * 2;
  const totalGap = GAP * (nodes.length - 1);
  const hPct = (innerH - totalGap) / nodes.length;
  nodes.forEach((node, i) => {
    const inset = node.level * INDENT_STEP;
    boxes.push({
      nodeId: node.id,
      xPct: SIDE_PAD + inset,
      yPct: PAD + i * (hPct + GAP),
      wPct: 100 - SIDE_PAD * 2 - inset,
      hPct,
      shapeType: 'rectangle',
      fill: paletteColor(theme, node.level === 0 ? i : i),
      textColor: theme.textColor,
    });
  });
  return { boxes, connectors: [] };
};
